module.exports = __webpack_public_path__ + "static/media/2405606f-e0e7-4b8e-9d20-92de884577ab.19feb277.JPG";